<script>
    import FavoritesService from '../../app-front/services/api/FavoitesService';

    export default {
        name: "Favorites",
        computed: {
            favoritesCount() {
                return this.favoritesItems.length
            },
            favoritesItems() {
                return this.$store.state.favorites.items;
            }
        },
        methods: {
            addFavorite(id) {
                FavoritesService.updateList(id)
                    .then(res => {
                        this.$store.commit('setFavorites', res.data)
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            getFavorites() {
                FavoritesService.getList()
                    .then(res => {
                        this.$store.commit('setFavorites', res.data);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            isFavorite(id) {
                return this.favoritesItems.indexOf(id) >= 0;
            },
            updateFavorites(id) {
                this.$store.commit('updateFavorites', id);
            }
        }
    }
</script>

<style scoped>

</style>
